import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function LinkSquareIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 5C2 3.34315 3.34315 2 5 2H10.5C11.0522 2 11.5 2.44772 11.5 3C11.5 3.55228 11.0522 4 10.5 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5522 20 20 19.5523 20 19V13.5C20 12.9477 20.4478 12.5 21 12.5C21.5522 12.5 22 12.9477 22 13.5V19C22 20.6569 20.6568 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z"
				fill="currentColor"
			/>
			<path
				d="M16 2C15.4477 1.99998 15 2.44768 15 2.99997C15 3.55225 15.4477 3.99998 16 4L18.5855 4.00016L11.2929 11.2929C10.9024 11.6834 10.9024 12.3166 11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071L20.0001 5.41403L20 8C20 8.5523 20.4477 9 21 9C21.5523 9 22 8.5523 22 8L22.0001 3.00026C22.0001 2.81142 21.9478 2.63481 21.8568 2.48413C21.8314 2.44202 21.803 2.40193 21.7718 2.36417C21.7513 2.33938 21.7297 2.31559 21.707 2.29289C21.7048 2.29076 21.7027 2.28864 21.7006 2.28652C21.5005 2.08998 21.2383 1.99455 20.9779 2.00024L16 2Z"
				fill="currentColor"
			/>
		</svg>
	);
}

LinkSquareIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default LinkSquareIcon;
